import { render, staticRenderFns } from "./award-audit.vue?vue&type=template&id=882af908&"
import script from "./award-audit.vue?vue&type=script&lang=js&"
export * from "./award-audit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports